<template>
    <validation-observer v-slot="{valid}">
        <b-overlay :show="authLoading" rounded spinner-variant="primary">
            <b-card
                header-bg-variant="primary"
                header="Вход"
                header-class="text-center text-light h4"
            >
                <login-form
                    v-model="form"
                    @change-captcha="changeCaptchaToken"
                    ref="form"
                    :show-captcha="showCaptcha"
                    :captchaSiteKey="captchaSiteKey"
                />
                <div class="d-flex mt-3 align-items-center justify-content-between flex-wrap">
                    <b-button-group>
                        <b-button
                            :disabled="!valid || !captchaIsVerify"
                            variant="primary"
                            @click="onPasswordLogin"
                        >Войти</b-button>
                        <b-button @click="onEcpLogin">
                            <b-spinner class="mr-1" v-if="tokenLoading" small type="border" />Войти используя ЭЦП
                        </b-button>
                    </b-button-group>
                    <b-button :to="{ name: 'auth' }" variant="success">Регистрация</b-button>
                    <ecp-modal
                        v-if="ecpLoginModal"
                        :hash="loginHash"
                        title="Выбор подписи для авторизации"
                        attached
                        @sign="loginBySign"
                        @hidden="ecpLoginModal = false"
                    >
                        <template v-slot:modal-footer="{ onSign }">
                            <b-button variant="danger" @click="ecpLoginModal = false">Отмена</b-button>
                            <b-button
                                :disabled="ecpLoginLoading"
                                variant="success"
                                @click="onSign"
                            >Войти по выбранной подписи</b-button>
                        </template>
                    </ecp-modal>
                </div>
                <template v-slot:footer>
                    <small>
                        <a class="text-muted" href="/reset-password">Восстановление доступа</a>
                    </small>
                </template>
            </b-card>
        </b-overlay>
    </validation-observer>
</template>
<script>
import LoginForm from "./LoginForm.vue";
import EcpModal from "../Ecp/EcpModal";
import authMixin from "./authMixin";

export default {
    name: "AuthLogin",
    components: { EcpModal, LoginForm },
    mixins: [authMixin],
};
</script>
